import { FC } from "react";

import { Stack, Shelf, useResponsive, useResponsiveDisplayMode } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold, Subheading } from "capitalrx-components-2.0/lib/typography";
import { Panel, Tag } from "capitalrx-components-2.0/lib/general";
// import { formatDollars } from "capitalrx-utilities";

import { STANDARD_RESPONSIVE_LAYOUT } from "@/constants";
import styles from "./BenefitSearchForm.module.scss";


interface ServiceMaximum {
  used: number;
  maximum: number;
  remaining: number;
  type: string;
  network: string[];
}

interface ResultPanelProps {
  service_category: string;
  service_maximum: ServiceMaximum;
}


export const ServiceMaxResultPanel: FC<ResultPanelProps> = ({ service_maximum, service_category }) => {
  const { Layout } = useResponsive(STANDARD_RESPONSIVE_LAYOUT);
  const displayMode = useResponsiveDisplayMode();

  return (
    <Stack>
      <Panel>
          <Stack spacing="medium-large">
            <Stack spacing="small" alignment="left">
              <Layout spacing={displayMode === "mobile" ? "small" : "medium"}>
                <Subheading>{service_category}</Subheading>
                {service_maximum?.network.includes("In-network") && (
                  <Shelf>
                    <Tag type="system-high-contrast">Covered In-Network</Tag>
                    <Shelf.Spacer />
                  </Shelf>
                )}
              </Layout>
              <Body style={service_maximum?.remaining === 0 ? { color: "#A81623" } : {}}>{service_maximum?.remaining}/{service_maximum?.maximum} visits remaining</Body>
            </Stack>
            <Stack spacing="small">
              <Body className={`${styles.SectionSpacer} ${styles.resultText}`}>
                networks
              </Body>
              <Semibold>
                {service_maximum?.network}
              </Semibold>
            </Stack>
          </Stack>
      </Panel>
    </Stack>
  );
};
